import grey from '@material-ui/core/colors/grey';

export default {
    root: {
        backgroundColor: grey[50]
    }
};
